//@ts-nocheck
import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme: any) => ({
  logo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor:'pointer',
    transition: 'all 0.5s ease-in-out',
    '.shrink &': {},
    [theme.breakpoints.up('lg')]: {
      // paddingRight: theme.spacing(8),
      '&.inner': {
        paddingRight: theme.spacing(0)
      }
    },
    '& a': {
      display: 'flex',
      flex: '0 0 100'
    }
  },

  LogoImage: {
    display: 'flex',
    alignItems: 'center',
    lineHeight: 0,
    '& img': {
      display: 'block',
      verticalAlign: 'middle',
      height: 32,
      width: 'auto',
      transition: 'all 0.5s ease-in-out',
    },
    objectFit: 'contain',
  },
  
}))
